module.exports = __webpack_public_path__ + "img/icon-archive-light-brown.3db95461.svg";